export const sizeMapNumbers = {'Link': 100, 'Tiny': 200, 'Narrow': 340, 'Normal': 600, 'Wide': 1000}

export const sizeMap = {
    'Link': String(sizeMapNumbers.Tiny) + 'px',
    'Tiny': String(sizeMapNumbers.Tiny) + 'px',
    'Narrow': String(sizeMapNumbers.Narrow) + 'px',
    'Normal': String(sizeMapNumbers.Normal) + 'px',
    'Wide': String(sizeMapNumbers.Wide) + 'px',
    'Max': '100%'
}

export const borderRadiusMap = {true: '7px', false: '0px'}

export const borderShadowMap = {true: '3px 10px', false: '0px 0px'}

export const smallWindowThreshold = 800;